import * as dom from '../utils/dom-utils.js';
import * as url from '../utils/url-utils.js';
import { fetchData } from '../utils/api-utils.js';

document.addEventListener('DOMContentLoaded', () => {
    const excludeParameters = ["country", "country2", "audience", "paudience", "disclaimer", "abp", "abp2", "iif", "cleardlcookie", "defaultaudience", "pagena", "clearprevurl", "prevurl", "vehicle"];

    const selectors = {
        hiddenSelectedCountry: 'input#hdnSelectedCountry',
        hiddenSelectedInvestorType: 'input#hdnSelectedAudience',
        hiddenCountryUrl: 'input#hdnCountryUrl',
        dataUrlSelector: 'input#hdnDataUrl',
        countries: 'div.countries',
        countrySelectClick: 'div.countries button',
        countryLabel: 'span.country_label',
        investorTypeButton: 'span.investortype_label',
        investorTypeSelectClick: 'div.investortypes button',
        investorTypeSelectClickRetail: 'div.investortypes button[data-id=retail]',
        investorTypeDropdown: 'div.investortypes',
        hiddenLanguage: 'input#hdnLanguage',
        disclaimerHeader: '#disclaimer-header',
        hiddenCurrentLanguage: '#hdnCurrentLanguage',
        disclaimerSection: '#disclaimer-section',
        disclaimerBlock: '#disclaimer_block',
        disclaimerBlockHeader: '#disclaimer_block .header',
        disclaimerBlockText: '#disclaimer_block div.mb-4.text',
        disclaimerBlockAgree: '#disclaimer_block .agree',
        disclaimerBlockDecline: '#disclaimer_block .decline',
        gatewayButton: '#gateway_button',
        currentCountryName: '#hdnCurrentCountryName',
        ahpLangDropdown: 'div#ahp-lang-dropdown',
        ahpLangDropdownButton: 'div#ahp-lang-dropdown #dropdownMenuButton',
        ahpLangDropdownClick: 'div#ahp-lang-dropdown ul li .dropdown-item',
        selectCountryText: '#select-country-text',
        selectedCountryName: '#hdnAhpSelectedCountryName',
        ahpLangDropdownList: '.ahp-dropdown div#ahp-lang-dropdown ul',
        siteLanguageSelector: 'div.gateway div#site-lang-dropdown ul .dropdown-item',
        gatewayModal: '.modal.gateway__modal.show'
    };

    const sitecountries = ["United States", "Australia", "Brazil", "Canada", "Chile", "China", "Peru", "Rest of Asia", "Rest of World"];

    const actionMethods = {
        getInvestorAndLanguages: 'getinvestorandlanguages',
        getTranslations: 'gettranslations',
        getDisclaimer: 'getdisclaimer'
    };

    const apiCall = (action, ...params) => fetchData(selectors.dataUrlSelector, action, ...params);
    
    const acceptClickEvent = (url, target = '_self') => {
        let decodedUrl = decodeURIComponent(url);
        const parentUrl = window.location.toString();
        if (parentUrl.match('#')) {
            decodedUrl += '#' + parentUrl.split('#')[1];
        }
        window.location.href = decodeURIComponent(decodedUrl);
        return false;
    };

    const declineClickEvent = (url, target = '_self') => acceptClickEvent(url, target);
    
    const handleDisclaimerData = (countryName) => (data) => {
        if (data.Text !== null && data.Text !== '') {
            dom.setHtml(selectors.disclaimerBlockHeader, data.Header);
        } else {
            dom.setHtml(selectors.disclaimerBlockHeader, '');
        }

        dom.setHtml(selectors.disclaimerBlockText, data.Text);
        dom.addAttribute(selectors.disclaimerBlockAgree, 'data-agree', data.AcceptUrl);
        dom.setText(selectors.disclaimerBlockAgree, data.AgreeText);
        dom.setText(selectors.disclaimerBlockDecline, data.DeclineText);
        dom.addAttribute(selectors.disclaimerBlockDecline, 'data-decline', data.DeclineUrl);
        dom.show(selectors.disclaimerBlockDecline);
        
        if (sitecountries.includes(countryName)) {
            dom.removeClass(selectors.disclaimerBlock, "disclaimer-eu");
        } else {
            dom.addClass(selectors.disclaimerBlock, "disclaimer-eu");
        }

        dom.show(selectors.disclaimerBlock);
        
        setupDisclaimerButtons();
        
        dom.removeAttribute(selectors.disclaimerBlockAgree, "disabled");
    };

    const setupDisclaimerButtons = () => {
        const agreeButton = dom.getElement(selectors.disclaimerBlockAgree);
        if (agreeButton) {
            agreeButton.addEventListener('click', (e) => {
                acceptClickEvent(dom.getDataAttribute(e.currentTarget, 'agree'), '_self');
            });
        }
        
        const declineButton = dom.getElement(selectors.disclaimerBlockDecline);
        if (declineButton) {
            declineButton.addEventListener('click', (e) => {
                declineClickEvent(dom.getDataAttribute(e.currentTarget, 'decline'), '_self');
            });
        }
    };

    const investorTypeSelection = (thisAction, event, action, investorType, selectedCountry, returnUrl, currentUrl, defaultDeepLinkSession, countryName) => {
        const investorId = dom.getDataAttribute(thisAction, 'id');
        dom.setValue(selectors.hiddenSelectedInvestorType, investorId);
        
        apiCall(
            action, 
            dom.getValue(selectors.hiddenSelectedInvestorType), 
            selectedCountry, 
            returnUrl, 
            currentUrl, 
            dom.getValue(selectors.hiddenLanguage), 
            defaultDeepLinkSession, 
            countryName
        )
        .then(handleDisclaimerData(countryName))
        .catch(error => console.error('Error fetching disclaimer:', error));
            
        return false;
    };

    const investorTypeButtonClick = (thisEvent, countryName, event = null) => {
        const currentUrl = encodeURIComponent(url.removeUrlParameters(excludeParameters, window.location.pathname + window.location.search));
        const defaultDeepLinkSession = dom.hasClass('body', 'disclaimer-deeplink') ? 'true' : '';
        
        dom.setHtml(selectors.investorTypeButton, thisEvent.innerHTML);
        
        investorTypeSelection(
            thisEvent, 
            event,
            actionMethods.getDisclaimer, 
            dom.getValue(selectors.hiddenSelectedInvestorType), 
            dom.getValue(selectors.hiddenSelectedCountry), 
            '', 
            currentUrl, 
            defaultDeepLinkSession, 
            countryName
        );
    };

    const changeAhpLanguage = (lang) => {
        const target = lang;
        const oldLanguageIso = dom.getValue(selectors.hiddenLanguage);
        dom.setValue(selectors.hiddenLanguage, dom.getDataAttribute(target, 'id'));

        let audienceType = dom.getValue(selectors.hiddenSelectedInvestorType);
        let countryIso = dom.getValue(selectors.hiddenSelectedCountry);
        let countryName = '';
        let countryUrl = dom.getValue(selectors.hiddenCountryUrl);
        
        const disclaimerHeaders = dom.getElements(selectors.disclaimerHeader);
        if (disclaimerHeaders.length > 1) {
            const disclaimerHeader = disclaimerHeaders[0];
            audienceType = dom.getDataAttribute(disclaimerHeader, 'audience');
            countryIso = dom.getDataAttribute(disclaimerHeader, 'countryiso');
            countryName = dom.getDataAttribute(disclaimerHeader, 'countryname');
            countryUrl = dom.getDataAttribute(disclaimerHeader, 'accepturl');
        } else {
            audienceType = dom.getValue(selectors.hiddenSelectedInvestorType);
            countryIso = dom.getValue(selectors.hiddenSelectedCountry);
            countryName = dom.getValue(selectors.selectedCountryName);
            countryUrl = dom.getValue(selectors.hiddenCountryUrl);
        }
        
        const defaultDeepLinkSession = dom.hasClass('body', 'disclaimer-deeplink') ? 'true' : '';
        
        const selectedCountryName = dom.getText(selectors.countryLabel);
        countryName = dom.getValue(selectors.selectedCountryName);
        if (countryName === "") {
            countryName = dom.getText(selectors.currentCountryName);
        }
        
        apiCall(
            actionMethods.getTranslations, 
            dom.getDataAttribute(target, 'id'), 
            audienceType, 
            countryIso, 
            countryUrl, 
            countryName, 
            oldLanguageIso, 
            defaultDeepLinkSession
        )
        .then((translation) => {
            dom.setText(".ahp-dropdown #dropdownMenuButton #ahpSelectedLanguage", target.innerHTML);
            
            translation.List.forEach((value) => {
                dom.getElements('.content-item-t').forEach((element) => {
                    const regex = new RegExp(value.Text, 'g');
                    const translatedHtml = element.innerHTML.replace(regex, value.TranslatedText);
                    element.innerHTML = translatedHtml;
                });
            });
            
            translation.LanguageList.forEach((value) => {
                dom.getElements('.language-content-item-t').forEach((element) => {
                    const regex = new RegExp(value.Text, 'g');
                    const translatedHtml = element.innerHTML.replace(regex, value.TranslatedText);
                    element.innerHTML = translatedHtml;
                });
            });
            
            for (let i = 0; i < translation.List.length; i++) {
                if (translation.List[i].Text.trim().toLowerCase() === selectedCountryName.trim().toLowerCase()) {
                    dom.setText(selectors.countryLabel, translation.List[i].TranslatedText.trim());
                    break;
                }
            }

            const disclaimerText = dom.getText(selectors.disclaimerBlockText);
            if (disclaimerText.trim().length > 1) {
                if (translation.Text !== null && translation.Text !== '') {
                    dom.setHtml(selectors.disclaimerBlockHeader, translation.Header);
                    dom.setHtml(selectors.disclaimerBlockText, translation.Text);
                    dom.addAttribute(selectors.disclaimerBlockAgree, 'data-agree', translation.AcceptUrl);
                    dom.setText(selectors.disclaimerBlockAgree, translation.AgreeText);
                    dom.setText(selectors.disclaimerBlockDecline, translation.DeclineText);
                    dom.addAttribute(selectors.disclaimerBlockDecline, 'data-decline', translation.DeclineUrl);
                    dom.show(selectors.disclaimerBlockDecline);
                } else {
                    dom.hide(selectors.disclaimerBlock);
                }
            }

            setupDisclaimerButtons();
        })
        .catch(error => console.error('Error fetching translations:', error));
    };
    
    const autoselectInvidualInvestor = () => {
        if (dom.getValue(selectors.hiddenSelectedInvestorType) === '') {
            dom.addAttribute(selectors.disclaimerBlockAgree, "disabled", "disabled");

            dom.click(selectors.investorTypeSelectClickRetail);

            dom.focus(selectors.disclaimerBlockAgree);

            const gatewayModal = dom.getElement(selectors.gatewayModal);
            const scrollToInvestor = dom.getElement('.scroll-to-investor');
            
            if (gatewayModal && scrollToInvestor) {
                const scrollTo = scrollToInvestor.getBoundingClientRect().top - 
                                gatewayModal.getBoundingClientRect().top + 
                                gatewayModal.scrollTop;
                                
                gatewayModal.scrollTo({
                    top: scrollTo,
                    behavior: 'smooth'
                });
            }
        }
    };
    
    const handleCountryClick = (e) => {
        const button = e.currentTarget;
        const countryName = dom.getDataAttribute(button, 'name');
        dom.setValue(selectors.selectedCountryName, countryName);
        const blockId = dom.getDataAttribute(button, 'blockid');
        const flagName = "dropdown mb-4 global-nav-flag country-" + countryName.toLowerCase().replace(/\s+/g, "-");
        
        const countryFlag = dom.getElement('#countryFlag');
        if (countryFlag) {
            countryFlag.className = flagName;
        }
        
        dom.setValue(selectors.hiddenSelectedCountry, dom.getDataAttribute(button, 'id'));
        dom.setHtml(selectors.countryLabel, e.target.innerText.trim());
        const hiddenLanguage = dom.getValue(selectors.hiddenLanguage);
        const currentUrl = encodeURIComponent(url.removeUrlParameters(excludeParameters, window.location.pathname + window.location.search));

        apiCall(
            actionMethods.getInvestorAndLanguages, 
            blockId, 
            hiddenLanguage, 
            dom.getDataAttribute(button, 'id'), 
            currentUrl
        )
        .then((json) => {
            dom.hide(selectors.disclaimerBlock);
            
            if (json.InvestorType !== null) {
                let investorHtml = '';
                Object.entries(json.InvestorType).forEach(([key, value]) => {
                    investorHtml += `<button data-id="${key}" class="dropdown-item dropdown__item text-util-sm content-item-t" role="menuitem" type="button" value="${value}">${value}</button>`;
                });
                dom.setHtml(selectors.investorTypeDropdown, investorHtml);
            }
            
            if (json.Languages !== null) {
                let languageHtml = '';
                let length = Object.keys(json.Languages).length;
                let hiddenLanguageInLanguages = false;
                
                if (length > 0) {
                    Object.entries(json.Languages).forEach(([key, value]) => {
                        languageHtml += `<li><a class="dropdown-item language-content-item-t" style="font-size:.624375rem;padding:8px" data-id="${key}">${value}</a></li>`;
                        if (hiddenLanguage.toLowerCase() === key.toLowerCase()) {
                            hiddenLanguageInLanguages = true;
                        }
                    });
                    dom.setHtml(selectors.ahpLangDropdownList, languageHtml);
                }
                
                if (length > 1 || !hiddenLanguageInLanguages) {
                    dom.show("#gateway-modal #language_dropdown_arrow");
                    dom.removeClass("#gateway-modal span.disclaimer-ahp-controls div#ahp-lang-dropdown ul.dropdown-menu", "hideEmptyLanguageDropdown");
                } else {
                    dom.hide("#gateway-modal #language_dropdown_arrow");
                    dom.addClass("#gateway-modal span.disclaimer-ahp-controls div#ahp-lang-dropdown ul.dropdown-menu", "hideEmptyLanguageDropdown");
                }
            }
            
            setupLanguageDropdownHandlers();

            dom.removeClass(selectors.countries, 'show');
            dom.setHtml(selectors.investorTypeButton, json.SelectInvestorText);

            setupInvestorTypeHandlers(countryName);
            
            const containsCountry = sitecountries.includes(countryName);
            if (!containsCountry) {
                dom.setValue(selectors.hiddenSelectedInvestorType, '');
                autoselectInvidualInvestor();
            }
        })
        .catch(error => console.error('Error fetching investor types and languages:', error));
            
        return false;
    };
    
    const setupLanguageDropdownHandlers = () => {
        dom.getElements(selectors.ahpLangDropdownClick).forEach((element) => {
            element.addEventListener('click', (e) => changeAhpLanguage(e.currentTarget));
        });
    };
    
    const setupInvestorTypeHandlers = (countryName) => {
        dom.getElements(selectors.investorTypeSelectClick).forEach((element) => {
            element.addEventListener('click', (e) => investorTypeButtonClick(e.currentTarget, countryName, e));
        });
    };
    
    const autoselectInvidualInvestorOnDeepLink = () => {
        const currentCountry = dom.getText(selectors.selectCountryText);
        
        if (sitecountries.includes(currentCountry)) return;

        autoselectInvidualInvestor();
    };
    
    const init = () => {
        dom.getElements(selectors.countrySelectClick).forEach((button) => {
            button.addEventListener('click', handleCountryClick);
        });
        
        dom.getElements(selectors.investorTypeSelectClick).forEach((element) => {
            element.addEventListener('click', (e) => {
                investorTypeButtonClick(e.currentTarget, dom.getText(selectors.currentCountryName), e);
            });
        });
        
        const gatewayButton = dom.getElement(selectors.gatewayButton);
        if (gatewayButton) {
            gatewayButton.addEventListener('click', () => dom.hide(selectors.disclaimerBlock));
        }
        
        setupDisclaimerButtons();
        
        dom.hide('.ahp-dropdown #site-lang-dropdown');
        dom.show('.ahp-dropdown #ahp-lang-dropdown');
        
        setupLanguageDropdownHandlers();
        
        dom.getElements(selectors.ahpLangDropdownButton).forEach((element) => {
            element.addEventListener('click', (e) => {
                const targetAnchor = e.currentTarget;
                const parent = targetAnchor.parentElement;
                
                if (parent) {
                    const showAllElements = parent.querySelectorAll('ul li div');
                    showAllElements.forEach((el) => {
                        if (el.parentElement) el.parentElement.style.display = '';
                    });
                    
                    const targetText = targetAnchor.textContent.trim();
                    const elementsToHide = parent.querySelectorAll('ul li div');
                    
                    elementsToHide.forEach((el) => {
                        if (el.textContent.includes(targetText) && el.parentElement) {
                            el.parentElement.style.display = 'none';
                        }
                    });
                }
            });
        });
        
        dom.getElements(selectors.siteLanguageSelector).forEach((element) => {
            element.addEventListener('click', (e) => {
                e.preventDefault();
                const selectedElement = e.currentTarget;
                const language = dom.getDataAttribute(selectedElement, 'language');
                const sourcePath = location.pathname + location.search;
                
                fetch("/common/languages/select/", {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    body: `language=${language}&sourcePath=${sourcePath}`
                })
                .then(response => response.text())
                .then(response => {
                    if (response !== '') {
                        const urlOverride = dom.getDataAttribute(selectedElement, 'url-override');
                        if (typeof urlOverride === 'string') {
                            location.href = urlOverride;
                            return;
                        }
                        location.href = url.removeUrlParameter(response, 'lang');
                    }
                })
                .catch(error => console.error('Error selecting language:', error));
            });
        });
        
        if (dom.hasClass('#gateway-modal', 'show')) {
            autoselectInvidualInvestorOnDeepLink();
        }
        
        const gatewayModal = dom.getElement('#gateway-modal');
        if (gatewayModal && typeof bootstrap !== 'undefined') {
            try {
                const bootstrapModal = new bootstrap.Modal(gatewayModal);
                gatewayModal.addEventListener('show.bs.modal', autoselectInvidualInvestorOnDeepLink);
            } catch (error) {
                console.warn('Bootstrap Modal initialization failed:', error);
                gatewayModal.addEventListener('show', autoselectInvidualInvestorOnDeepLink);
            }
        }
    };
    
    init();
});